import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule, XHRBackend, RequestOptions } from '@angular/http';

import { AppComponent } from './app.component';
import { AccordionModule } from 'ng2-bootstrap/components/accordion';
import { DropdownModule } from 'ng2-bootstrap/components/dropdown';
import { SlimScrollModule } from 'ng2-slimscroll';
import { ModalModule } from 'ng2-bootstrap/ng2-bootstrap';
import { ClickOutsideModule } from 'ng2-click-outside';
import { ScheduleModule, CalendarModule, TooltipModule } from 'primeng/primeng';
import { HttpInterceptor, httpFactory, AuthGuard, MessageEvent, SignInEvent, LoaderEvent, FacilityListEvent, OpenFrameEvent, HiddenFooter, SidemenuToCalendarEvent, SidemenuToViewFacilityEvent, Broadcaster, SidemenuSubCategory, HandleSideMenuWithAuth, SetAllMemberCheck } from './shared/index';

import { AppService } from './app.service';
import {FacilityModule } from './facility/facility.module';
import {AuthenticationModule } from './authentication/authentication.module';
import {FeedModule } from './feed/feed.module';
import {MemberModule } from './member/member.module';
import {FeedbackModule} from './feedback/feedback.module';
import {OnBoardingModule} from './on-boarding/on-boarding.module';
import {GroupModule} from './group/group.module';
import {SharedModule} from './shared/shared.module';
import {PrimecalendarModule } from './primecalendar/primecalendar.module';
import {PrivacyModule} from './privacy/privacy.module';
import {AppRoutingModule} from './app-routing.module';

@NgModule({
  declarations: [
    AppComponent],
  entryComponents: [AppComponent],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    AccordionModule,
    AppRoutingModule,
    DropdownModule,
    ModalModule,
    ClickOutsideModule,
    TooltipModule,
    FacilityModule,
    MemberModule,
    FeedModule,
    FeedbackModule,
    OnBoardingModule,
    GroupModule,
    SharedModule,
    PrimecalendarModule,
    SlimScrollModule,
    PrivacyModule,
    AuthenticationModule // this module should at last
  ],
  providers: [ 
    {
      provide: HttpInterceptor,
      useFactory: httpFactory,
      deps: [XHRBackend, RequestOptions]
    }, AppService, AuthGuard, MessageEvent, SignInEvent, LoaderEvent, FacilityListEvent, OpenFrameEvent, HiddenFooter, SidemenuToCalendarEvent, SidemenuToViewFacilityEvent, Broadcaster, SidemenuSubCategory, HandleSideMenuWithAuth, SetAllMemberCheck ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts